/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Status/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFormat from 'Data/format.js'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Status({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/TopBar/Order/Content/Content/OrderStatuses/Content/OrderStatus/Status"
  
}) {
let orderStatusStatusValueData = fromData.useDataFormat({ viewPath,
context: 'order_status',
path: 'status',
format: fromFormat.toSentenceCase,
})
let dtColorsNeutral900 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.900'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 weight="medium"
 color={dtColorsNeutral900}
 data="order_status.status"
 format="/Data/format.js toSentenceCase"
 text={orderStatusStatusValueData}
/>
{children}
</React.Fragment>)
}